"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _input = _interopRequireDefault(require("../../../../../core/input"));
var _inputOnBlur = _interopRequireDefault(require("../../../../../core/input-on-blur"));
var _rowConfig = _interopRequireDefault(require("../../../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../../../core/label"));
var _col = _interopRequireDefault(require("../../../../../core/col"));
var _selectCode = _interopRequireDefault(require("../../../../../core/select-code"));
var _checkmark = _interopRequireDefault(require("../../../../../core/checkmark"));
var _alert = _interopRequireDefault(require("../../../../../core/alert"));
var _dateTime = require("../../../../../../schema/scalars/date-time");
var _editRtcsForm = _interopRequireDefault(require("../edit-rtcs-form"));
var _PanCelticEntry = _interopRequireDefault(require("../../../../../core/PanCelticEntry"));
var _getQueryResponse = _interopRequireDefault(require("../../../../../../entryFunctions/getQueryResponse"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "info"
}, "Changing a paddlers details here will only change them for this entry and not for any other entries at this competition. If the paddler wishes to update their details in the ranking lists and for future entries then they should contact their ranking officer.");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Paddler Ranking");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Entry Type");
var _ref4 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Entry Date");
var _ref5 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Paddler Name");
var _ref6 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Contact Email");
var _ref7 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Start List Bib");
var _ref8 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Age Category");
var _ref9 = /*#__PURE__*/_react.default.createElement("span", {
  className: "text-info"
}, "Enter year of birth to update age category");
var _ref10 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Club");
var _ref11 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Sponsor");
var _ref12 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Organiser Free Code");
var _ref13 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Pan-Celtic");
var _ref14 = /*#__PURE__*/_react.default.createElement(_label.default, null, "School");
var _ref15 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Has Paid");
var _ref16 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Late Entry");
var _ref17 = /*#__PURE__*/_react.default.createElement("h4", {
  className: "card-header"
}, "RTC Codes");
class EditEntryForm extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      isEditingAge: false
    });
    _defineProperty(this, "_editAgeCat", () => {
      this.setState({
        isEditingAge: true
      });
    });
    _defineProperty(this, "_updateAgeCat", year => {
      this.props.onUpdateAgeCategory(this.props.entry.id, year);
      this.setState({
        isEditingAge: false
      });
    });
  }
  _displayDateTime(value) {
    if (!value) return '';
    const datePart = value.split('T')[0];
    const timePart = value.split('T')[1].split('.')[0];
    return (0, _occasion.default)(datePart, 'D MMM') + ' ' + timePart.substring(0, 5);
  }
  render() {
    const entry = this.props.entry;
    return /*#__PURE__*/_react.default.createElement("div", null, _ref, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4,
        md: 3
      }, {
        sm: 8,
        md: 9
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, entry.rankingDivisionDescription + ' ' + entry.classDescription + (entry.bibNumber ? ' - Bib ' + entry.bibNumber : ''))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, entry.entryTypeDescription)), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_col.default, null, entry.isOnlineEntry ? this._displayDateTime(entry.entrySortDate) : /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "Date",
      name: "entrySortDate",
      value: entry.entrySortDate.split('T')[0],
      onChange: value => this.props.onUpdateEntry((0, _dateTime.dateTimeFromDate)(value), 'entrySortDate'),
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref5, /*#__PURE__*/_react.default.createElement(_col.default, null, entry.isOnlineEntry ? entry.bibName : /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "text",
      name: "bibName",
      value: entry.bibName,
      onChange: this.props.onUpdateEntry,
      maxLength: 100,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref6, /*#__PURE__*/_react.default.createElement(_col.default, null, entry.isOnlineEntry ? entry.contactEmail : /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "email",
      name: "contactEmail",
      value: entry.contactEmail,
      onChange: this.props.onUpdateEntry,
      required: false,
      maxLength: 100
    }))), entry.bibNumber && entry.competitionDivision.isRanking ? null : /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref7, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "Integer",
      name: "startListBib",
      value: entry.startListBib,
      onChange: this.props.onUpdateEntry,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref8, /*#__PURE__*/_react.default.createElement(_col.default, null, !this.state.isEditingAge ? /*#__PURE__*/_react.default.createElement("button", {
      className: "form-control text-xs-left",
      onClick: this._editAgeCat
    }, entry.ageCategory.description) : /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "Year",
      name: "yearOfBirth",
      value: null,
      maxLength: 4,
      onChange: value => this._updateAgeCat(value),
      autoFocus: true,
      onBlur: () => this.setState({
        isEditingAge: false
      })
    }), _ref9))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref10, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "PaddlerClubs",
      name: "paddlerClubID",
      value: entry.paddlerClubID,
      onChange: value => this.props.onUpdateEntry(value, 'paddlerClubID'),
      clearable: true,
      yearID: entry.yearID
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref11, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "sponsor",
      type: "Sponsor",
      value: entry.sponsor,
      onChange: this.props.onUpdateEntry,
      maxLength: 100
    }))), !this.props.useFreeCode ? null : /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref12, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "freeCode",
      value: entry.freeCode,
      onChange: this.props.onUpdateEntry,
      maxLength: 5
    }))), !entry.race.specialRefs || !entry.race.specialRefs.includes('PANC') ? null : /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref13, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_PanCelticEntry.default, {
      entry: entry,
      queryResponse: (0, _getQueryResponse.default)('PANC', entry.queryResponses),
      onSetResponse: this.props.onUpsertQueryResponse
    }))), !entry.race.specialRefs || !entry.race.specialRefs.includes('SCSC') ? null : /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref14, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "text",
      name: "SCSC",
      value: (0, _getQueryResponse.default)('SCSC', entry.queryResponses),
      onChange: this.props.onUpsertQueryResponse
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref15, /*#__PURE__*/_react.default.createElement(_col.default, null, entry.isOnlineEntry ? /*#__PURE__*/_react.default.createElement(_checkmark.default, {
      checked: entry.hasPaid
    }) : /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      name: "hasPaid",
      checked: entry.hasPaid,
      onChange: this.props.onUpdateEntry
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref16, /*#__PURE__*/_react.default.createElement(_col.default, null, entry.isOnlineEntry ? /*#__PURE__*/_react.default.createElement(_checkmark.default, {
      checked: entry.isLateEntry
    }) : /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      name: "isLateEntry",
      checked: entry.isLateEntry,
      onChange: this.props.onUpdateEntry
    })))), /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref17, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement(_editRtcsForm.default, {
      entry: entry
    }))));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(EditEntryForm, "partialQueries", {
  Entry: _mergeBqlQueries(_mergeBqlQueries({
    id: true,
    bibName: true,
    entrySortDate: true,
    isOnlineEntry: true,
    rankingDivisionDescription: true,
    classDescription: true,
    bibNumber: true,
    yearID: true,
    paddlerClubID: true,
    sponsor: true,
    contactEmail: true,
    entryTypeDescription: true,
    freeCode: true,
    hasPaid: true,
    isLateEntry: true,
    ageCategory: {
      description: true
    },
    queryResponses: {
      id: true,
      specialRef: true,
      response: true
    },
    race: {
      specialRefs: true
    }
  }, _editRtcsForm.default.partialQueries.Entry), _PanCelticEntry.default.partialQueries.Entry)
});
var _ref18 = {
  "refCodes(codeType:\"rtc\")": {
    id: true,
    refCode: true,
    description: true,
    isExpired: true
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(EditEntryForm, props => _ref18, (client, props) => ({
  onUpdateEntry(value, field) {
    return client.update('Entry.set', {
      id: props.entry.id,
      field,
      value
    });
  },
  onUpdateAgeCategory(id, yearOfBirth) {
    return client.update('Entry.updateAgeCategory', {
      id,
      yearOfBirth
    });
  },
  onUpsertQueryResponse(response, specialRef) {
    return client.update('QueryResponse.upsert', {
      entryID: props.entry.id,
      specialRef,
      response
    });
  }
}));